import styled, { css } from 'styled-components';
import { Icon } from './Icon';
const SourceIcon = styled(Icon) `
  && {
    font-family: 'Icomoon';

    /**
     * These icons can be provided with primary and secondary colors as defined in our dataSourceConstants.
     */
    color: ${({ primaryColor, theme }) => primaryColor || `${theme.ThemeColors.TEXT.hex}`};

    ${({ secondaryColor }) => secondaryColor && css `
      box-sizing: border-box;
      border-bottom: .25rem solid ${secondaryColor};
    `}

    /**
     * Inverting colors means taking the primaryColor and using it for a background and having the fill be white, used often in SourceBadges.
     */
    ${({ invertColors, primaryColor, theme }) => invertColors && css `
      color: white;
      padding: 0.25em;
      background-color: ${primaryColor || theme.ThemeColors.TEXT.hex};
    `}

    ${({ icon }) => !icon || !icon.content && css `
      padding-left: 1rem;
    `}
  }
`;
export { SourceIcon };
